import { formatDollarStr, formatPercentStr } from '@assets/utils/Formatting';

export const formatDollarCustom = (postfix: string) => {
    return (data: any) => {
        return formatDollarStr(data.toString()) + postfix;
    };
};
export const formatDollar = (data: any) => {
    if (!data && data !== 0) {
        data = '';
    }
    return formatDollarStr(data.toString());
};

export const formatPercent = (data: any) => {
    if (!data && data !== 0) {
        data = '';
    }
    return formatPercentStr(data.toString());
};

export const formatPercentNoMultiply = (data: any) => {
    if (!data && data !== 0) {
        data = '';
    }
    return formatPercentStr(data.toString(), 1);
};

export const noFormat = (data: any) => {
    if (!data) {
        data = '';
    }
    return data.toString();
};

export const noFormatRaw = (data: any) => {
    return data;
};
